import script from "./web-footer.vue?vue&type=script&setup=true&lang=js"
export * from "./web-footer.vue?vue&type=script&setup=true&lang=js"

import "./web-footer.vue?vue&type=style&index=0&id=da3ea1d2&lang=scss&scoped=true"

import exportComponent from "/root/.jenkins/workspace/qd-brcashy-h5-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-da3ea1d2"]])

export default __exports__